export default function LoadingSpinner({ size = 'md', className = '', fullHeight = false }) {
  const sizeClasses = {
    sm: 'w-5 h-5 border-2',
    md: 'w-8 h-8 border-3',
    lg: 'w-12 h-12 border-4',
  };

  return (
    <div className={`flex items-center justify-center py-12 ${fullHeight ? 'min-h-[50vh]' : 'min-h-[200px]'} ${className}`}>
      <div
        className={`
          ${sizeClasses[size]}
          border-brand-amber/30 border-t-brand-orange
          rounded-full animate-spin
        `}
      />
    </div>
  );
}
